// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"21":"0903cd3ff20157e5","373":"1d286f6f78ee5500","470":"8800917abdfa1b41"}[chunkId] + ".css";
};